import React, {useContext,useState,useEffect,useRef, startTransition, useMemo, useCallback } from "react";
import { AppContext } from "../../context/AppContext";
import { IoMdHeart,IoMdHeartEmpty } from "react-icons/io";
import "./containerRestau.css"
import { fetchWithRefreshUser,slugify } from "../types/types";
import { FaMapMarkerAlt } from "react-icons/fa";
import { MdOutlineStar } from "react-icons/md";
import { IoPersonSharp } from "react-icons/io5";
import { Link } from "react-router-dom";

interface containerRestauProps {
    id:number,
    idResto:number,
    img : string,
    note: number,
    name: string,
    id_url:string,
    imgSup?:string[],
    isFav:boolean,
    type:string[],
    visibleCity?:string,
    city:string,
    nbr_review:number,
    total_price:number,
    cuisines:[string,string],
    isLarge?:boolean,
    date_published?:Date,
    imgLocked?:boolean,
}
const preloadAndDecode = (src: string) =>
    new Promise<void>((resolve) => {
        const im: HTMLImageElement = new Image();
        im.src = src;
        const done = () => resolve();
        if ("decode" in im) {
        im.decode()
            .then(done)
            .catch(() => {
            im.onload = done;
            im.onerror = done;
            });
        } else {
        (im as HTMLImageElement).onload = done;
        (im as HTMLImageElement).onerror = done;
        }
});
const ContainerRestauInner:React.FC<containerRestauProps> = ({id,isLarge=false,imgLocked=false,date_published,id_url,idResto,img,city,visibleCity,note,name,imgSup,isFav,type,nbr_review,total_price,cuisines}) => {
    const {isLogin,setConnectionScreen,restoFav,setRestoFav} = useContext(AppContext)

    const [fav,setFav] = useState(restoFav.includes(idResto))
    useEffect(() => {
        setFav(restoFav.includes(idResto))
    },[restoFav])
    const activeImageIndex = useRef<number[]>([0,1]);
    const [currentImgPhone, setCurrentImgPhone] = useState(0);

    const canHover = useMemo(() => 
        typeof window !== "undefined" && window.matchMedia("(hover: hover) and (pointer: fine)").matches,
    []);

    const [isSwipePhone,setIsSwipePhone] = useState(false)

    const [isSlide, setIsSlide] = useState(false)
    const [isHovered, setIsHovered] = useState(false)
    const [isFirst, setIsFirst] = useState(true)
    const [zindexBase,setZindexBase] = useState(-1)
    const containerRef = useRef<HTMLDivElement>(null);
    const timeouts = useRef<NodeJS.Timeout[]>([]);
    const images = useMemo(() => imgSup ? [img,...imgSup] : [img], [img, imgSup]);
    let isNew = false
    if(date_published) {
        const now = Date.now();
        const publishedAt = new Date(date_published).getTime();
        isNew = (now - publishedAt) < 1000 * 60 * 60 * 24 * 14;
    }
    const linkResto = useMemo(() => {
        const slugcity = slugify(city)
        const slugName = slugify(name)
        return  `/restaurant/${slugcity}/${slugName}_${id_url}?src=home`
    },[city,name,id_url])

    useEffect(() => {
        if (window.innerWidth <= 768) return;
        timeouts.current.forEach((timeout) => clearTimeout(timeout));
        timeouts.current = [];
        timeouts.current.push(
        setTimeout(() => {
        if(isHovered && images.length > 1) {
            const slideFirst = document.getElementById('slideFirstRestau'+id)
            const slideSecond = document.getElementById('slideSecondRestau'+id)
            if(isFirst && slideFirst && slideSecond) {
                slideFirst.classList.add('sliding')
                slideSecond.style.zIndex = '0'
                slideSecond.classList.remove('right')
                timeouts.current.push(
                    setTimeout(() => {
                            slideFirst.style.zIndex = '-10'
                            slideFirst.classList.remove('sliding')
                            slideFirst.classList.add('right')
                    },750 ))
                
            }
            else if(!isFirst && slideFirst && slideSecond) {
                slideSecond.classList.add('sliding')
                slideFirst.style.zIndex = '0'
                slideFirst.classList.remove('right')
                timeouts.current.push(
                    setTimeout(() => {
                        slideSecond.style.zIndex = '-10'
                        slideSecond.classList.remove('sliding')
                        slideSecond.classList.add('right')
                    },750 )    
                )  
            }
            timeouts.current.push(
            setTimeout(() => {
                if(isHovered) {
                    if(isFirst) activeImageIndex.current = [activeImageIndex.current[1]+1 >= images.length ? 0 : activeImageIndex.current[1]+1,activeImageIndex.current[1]]
                    else activeImageIndex.current = [activeImageIndex.current[0],activeImageIndex.current[0]+1 >= images.length ? 0 : activeImageIndex.current[0]+1]
                    setIsFirst(!isFirst)
                }
            },1000)  
            )  
        }
        else if (isHovered) {
            const container = document.getElementById('containerRestau'+id)
            if(container) {
                container.classList.add('noDefilment');
                setTimeout(() => container.classList.remove('noDefilment'), 200);
            }
        }
        else {
            handleMouseLeave()
        }
        return () => {
            timeouts.current.forEach((timeout) => clearTimeout(timeout));
            timeouts.current = [];
          };
        },500))

    },[isHovered,isFirst])


    const handleMouseEnter = () => {
        if (window.innerWidth <= 765) return;
        setIsFirst(true)
        timeouts.current.forEach((timeout) => clearTimeout(timeout));
        timeouts.current = []     
        const slideFirst = document.getElementById('slideFirstRestau'+id)
        const slideSecond = document.getElementById('slideSecondRestau'+id)
        if(slideFirst && slideSecond) {
            slideFirst.style.transition = 'transform 0.7s ease '
            slideSecond.style.transition = 'transform 0.7s ease'
            setZindexBase(-1)
            setIsHovered(true)
        }
    }
    const handleMouseLeave = () => {
        if (window.innerWidth <= 765) return;
        timeouts.current.forEach((timeout) => clearTimeout(timeout));
        timeouts.current = []
        setIsHovered(false)
        activeImageIndex.current = [0,1]
        setZindexBase(1)
        const slideFirst = document.getElementById('slideFirstRestau'+id)
        const slideSecond = document.getElementById('slideSecondRestau'+id)
        if(slideFirst && slideSecond) {
            slideFirst.style.transition = 'transform 0.001s linear';
            slideSecond.style.transition = 'transform 0.001s linear';
            slideFirst.style.zIndex='0'
            slideSecond.style.zIndex='0'
            slideFirst.classList.remove('sliding','right')
            slideSecond.classList.remove('sliding')
            slideSecond.classList.add('right') 
        }
            
    }
    const [possibleLike, setPossibleLike] = useState(true)
    const handleFav = async () => {
        if (isLogin === 0) {
            startTransition(() => {setConnectionScreen(true)});
        } else {
            if (possibleLike) {
                try {
                    setPossibleLike(false)
                    const token = localStorage.getItem('token');
                    const response = await fetchWithRefreshUser(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/updateFav`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        },
                        credentials: 'include',
                        body: JSON.stringify({idrestaurant: idResto}),
                    });
                    if(fav) setRestoFav(prev => prev.filter(id => id !== idResto));
                    else setRestoFav([...restoFav,idResto])
                    setFav(!fav); 
                    
                    if (!response) {
                        throw new Error('Erreur lors de la mise à jour du favori');
                    }
                    
                    setTimeout(() => {
                        setPossibleLike(true)
                    },1000)
                } catch (error) {
                    console.error("Erreur lors de la mise à jour en base de données", error);
                }
            }
        }
    }
    const touchStartX= useRef(0);
    const touchStartY= useRef(0);
    const touchStartTime = useRef(0);
    const lastTouchX = useRef(0);
    const currentImgRef = useRef(0);
    useEffect(() => {
        currentImgRef.current = currentImgPhone;
    }, [currentImgPhone]);

    const isDragging = useRef(false);
    const swipeDirection = useRef<1 | -1 | 0>(0); 
    const cardWidthRef = useRef(0);
    const didPreloadFirstSwipeRef = useRef(false);
    const slideCenterRef = useRef<HTMLDivElement>(null);
    const slideOtherRef = useRef<HTMLDivElement>(null);
    const imgCenterRef = useRef<HTMLImageElement | null>(null);
    const imgOtherRef = useRef<HTMLImageElement | null>(null);

    const centerIdxRef = useRef(0);
    const otherIdxRef = useRef(images.length > 1 ? 1 : 0);
    const isTransitioning = useRef(false);

    useEffect(() => {
        if (imgLocked) return;
        centerIdxRef.current = 0;
        otherIdxRef.current = images.length > 1 ? 1 : 0;
        if (imgCenterRef.current) imgCenterRef.current.src = images[0];
        if (imgOtherRef.current) imgOtherRef.current.src = images[otherIdxRef.current];
        setCurrentImgPhone(0);
    }, [imgLocked,images]);
    const updateUpInfo = useCallback((prevId:number) => {return prevId+1 >= images.length ? 0 : prevId+1},[images.length]);
    const updateDownInfo = useCallback((prevId:number) => {return prevId-1 < 0 ? images.length-1 : prevId-1},[images.length]);

    const handleTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
        if (canHover || images.length <= 1 || isSwipePhone ||  isTransitioning.current) return;
        if (!didPreloadFirstSwipeRef.current) {
            didPreloadFirstSwipeRef.current = true;

            const nextIdx = images.length > 1 ? 1 : 0;
            const nextSrc = images[nextIdx];
            preloadAndDecode(nextSrc)
        }
        e.stopPropagation();

        const touch = e.touches[0];
        touchStartX.current = touch.clientX;
        touchStartY.current = touch.clientY;
        lastTouchX.current = touch.clientX;
        touchStartTime.current = performance.now();

        isDragging.current = true;
        swipeDirection.current = 0;
        setIsSlide(true);

        if (containerRef.current) cardWidthRef.current = containerRef.current.offsetWidth || window.innerWidth;

        const slideCenter = slideCenterRef.current;
        const slideOther = slideOtherRef.current;
        if (slideCenter && slideOther) {
            slideCenter.style.transition = 'none';
            slideOther.style.transition = 'none';
            slideCenter.style.transform = 'translateX(0px)';
            slideOther.style.transform = 'translateX(100%)';
            slideCenter.style.zIndex = '2';
            slideOther.style.zIndex = '1';
            slideCenter.style.opacity = "1";
            slideOther.style.opacity = '1';

        }
    };
    
    useEffect(() => {
        const container = containerRef.current;
        if (!container || canHover || images.length <= 1) return;

        const handleMove = (e: TouchEvent) => {
            if (!isDragging.current || isTransitioning.current) return;

            const touch = e.touches[0];
            const touchX = touch.clientX;
            const touchY = touch.clientY;

            const deltaX = touchX - touchStartX.current;
            const deltaY = touchY - touchStartY.current;

            if (swipeDirection.current === 0) {
                if (Math.abs(deltaX) < 5 && Math.abs(deltaY) < 5) return;
                if (Math.abs(deltaY) > Math.abs(deltaX) * 1.2) {
                    isDragging.current = false;
                    return;
                }

                swipeDirection.current = deltaX < 0 ? -1 : 1;
                const baseIndex = centerIdxRef.current;
                const nextIndex =
                    swipeDirection.current === -1
                        ? updateUpInfo(baseIndex)
                        : updateDownInfo(baseIndex);
                if (imgOtherRef.current) {
                imgOtherRef.current.src = images[nextIndex];
                }
                otherIdxRef.current = nextIndex;
            }else {
                const newDirection = deltaX < 0 ? -1 : 1;
                if (newDirection !== swipeDirection.current && Math.abs(deltaX) > 10) {
                    swipeDirection.current = newDirection;
                    const baseIndex = centerIdxRef.current;
                    const nextIndex =
                        swipeDirection.current === -1
                            ? updateUpInfo(baseIndex)
                            : updateDownInfo(baseIndex);

                    otherIdxRef.current = nextIndex;
                    if (imgOtherRef.current) imgOtherRef.current.src = images[nextIndex];
                }
            }
            if (e.cancelable) e.preventDefault();
            lastTouchX.current = touchX;

            const slideCenter = slideCenterRef.current;
            const slideOther = slideOtherRef.current;
            if (!slideCenter || !slideOther) return;

            const width = cardWidthRef.current|| 1;
            const direction = swipeDirection.current;

            slideCenter.style.transition = 'none';
            slideOther.style.transition = 'none';

            if (direction === -1) {
                const offsetCenter = deltaX;
                const offsetOther = width + deltaX;
                slideCenter.style.transform = `translateX(${offsetCenter}px)`;
                slideOther.style.transform = `translateX(${offsetOther}px)`;
            } else if (direction === 1) {
                const offsetCenter = deltaX;
                const offsetOther = -width + deltaX;
                slideCenter.style.transform = `translateX(${offsetCenter}px)`;
                slideOther.style.transform = `translateX(${offsetOther}px)`;
            }
        };
        container.addEventListener('touchmove', handleMove, { passive: false });

        return () => {
            container.removeEventListener('touchmove', handleMove);
        };
    }, [canHover, images.length, id, updateUpInfo, updateDownInfo]); 

    const handleTouchEnd =  (e: React.TouchEvent<HTMLDivElement>) => {
        if (canHover || images.length <= 1 || isTransitioning.current) return;
        e.stopPropagation();

        if (!isDragging.current) return;
        isDragging.current = false;

        const container = containerRef.current;
        const slideCenter = slideCenterRef.current;
        const slideOther = slideOtherRef.current;
        if (!container || !slideCenter || !slideOther) return;

        const width = cardWidthRef.current || container.offsetWidth || 1;
        const deltaX = lastTouchX.current - touchStartX.current;
        const duration = performance.now() - touchStartTime.current;
        const absDeltaX = Math.abs(deltaX);
        const direction = swipeDirection.current; 

        if (direction === 0) {
            slideCenter.style.transition = 'transform 0.25s ease';
            slideOther.style.transition = 'transform 0.25s ease';
            slideCenter.style.transform = 'translateX(0px)';
            slideOther.style.transform = 'translateX(100%)';
            swipeDirection.current = 0;
            return;
        }
        const HALF_THRESHOLD = width * 0.5;
        const FAST_SWIPE_DISTANCE = width * 0.15;
        const FAST_SWIPE_TIME = 220;

        const isOverHalf = absDeltaX > HALF_THRESHOLD;
        const isFastSwipe = absDeltaX > FAST_SWIPE_DISTANCE && duration < FAST_SWIPE_TIME;
        const shouldChange = isOverHalf || isFastSwipe;

        slideCenter.style.transition = 'transform 0.25s ease';
        slideOther.style.transition = 'transform 0.25s ease';

        if (shouldChange) {
            isTransitioning.current = true;
            setIsSwipePhone(true);
            setCurrentImgPhone(otherIdxRef.current);
            const w = width;
            const dir = direction;

            slideCenter.style.transition = "transform 0.25s ease";
            slideOther.style.transition = "transform 0.25s ease";

            slideCenter.style.transform = `translateX(${dir === -1 ? -w : w}px)`;
            slideOther.style.transform = "translateX(0px)";

            const onEnd = () => {
                slideCenter.removeEventListener("transitionend", onEnd);
                centerIdxRef.current = otherIdxRef.current;
                if (imgCenterRef.current && imgOtherRef.current) {
                    imgCenterRef.current.src = imgOtherRef.current.src;
                }

                requestAnimationFrame(() => {
                    slideCenter.style.transition = "none";
                    slideOther.style.transition = "none";
                    slideCenter.style.transform = "translateX(0px)";
                    slideOther.style.transform = "translateX(100%)";
                    swipeDirection.current = 0;
                    const nextOther = updateUpInfo(centerIdxRef.current);
                    otherIdxRef.current = nextOther;
                    if (imgOtherRef.current) imgOtherRef.current.src = images[nextOther];


                    isTransitioning.current = false;
                    setIsSwipePhone(false);
                });
            };
            slideCenter.addEventListener("transitionend", onEnd);
        } else {
            slideCenter.style.transform = 'translateX(0)';
            slideOther.style.transform = direction === -1 ? 'translateX(100%)' : 'translateX(-100%)';
            setTimeout(() => {
                slideCenter.style.transition = 'none';
                slideOther.style.transition = 'none';
                slideCenter.style.transform = 'translateX(0px)';
                slideOther.style.transform = 'translateX(100%)';
                swipeDirection.current = 0;
            }, 260);
        }
    };

    const handleCurrentImg = (index:number) => {
        if (index === centerIdxRef.current || isSwipePhone || isTransitioning.current || images.length <= 1) return;
        isTransitioning.current = true;
        const nextOther = updateUpInfo(index);
        centerIdxRef.current = index;
        otherIdxRef.current = nextOther;
        if (imgCenterRef.current) imgCenterRef.current.src = images[index];
        if (imgOtherRef.current) imgOtherRef.current.src = images[nextOther];
        setCurrentImgPhone(index);
        setTimeout(() => {
            isTransitioning.current = false;
        }, 50);
    }

    return (
        <div className={`containerRestauUp ${id%3 !== 0 && 'notFirst'} ${isLarge && 'large'} ${canHover ? 'canHover' : 'cantHover'}`}>
            {images.length > 1 && <div className="slideImgPhone flexAllCenter" style={{width: images.length > 4 ? '15%' : (images.length > 3 ? '13%' : images.length > 2 ? '10%' : '8%') }}>
                    {
                        images.map((elem,id) => {
                            return <div key={'elemSlidephone'+id} className={`${currentImgPhone === id && 'select'} ${(currentImgPhone === id+1 || currentImgPhone === id-1) && 'nextSelect'}`} onClick={() => {if(currentImgPhone !== id){handleCurrentImg(id)}}}>

                            </div>
                        })
                    }
                </div>}
            <Link to={linkResto} state={{ skipSplash: true }} target="_blank" rel="noopener" className='containerRestau' id={`containerRestau`+id}  onMouseEnter={handleMouseEnter}  onMouseLeave={handleMouseLeave} >
                 {canHover ? <>
                <div className="slideBase forComputer" id={'slideBaseRestau'+id} style={{zIndex:zindexBase}} >
                    {images[activeImageIndex.current[0]] && !imgLocked && <img src={images[activeImageIndex.current[0]]} loading={id === 0 ? "eager" : "lazy"} {...(id === 0 && { fetchpriority: 'high' })} alt="illustration du restaurant"/> }
                </div>
                <div className="slideFirst forComputer" id={'slideFirstRestau'+id} >
                    {images[activeImageIndex.current[0]] && isHovered &&  <img  src={images[activeImageIndex.current[0]]} loading="eager"  decoding="async" alt="illustration du restaurant"/>}
                </div>
                <div className="slideSecond right forComputer"  id={'slideSecondRestau'+id} >
                    { isHovered && <img  src={images[activeImageIndex.current[1]]} loading="lazy"  decoding="async" alt="illustration du restaurant"/> }
                </div></> :

                <div onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd}  ref={containerRef}> 
                    <div className="slideFirst forPhone " id={`slideRestauPhone0`+id} ref={slideCenterRef}>
                        { !imgLocked && <img ref={imgCenterRef}  loading={id === 0 ? "eager" : "lazy"}  alt="illustration du restaurant" {...(id === 0 && { fetchpriority: 'high' })}/> }
                    </div>

                    <div className="slideSecond forPhone"  id={`slideRestauPhone1`+id} ref={slideOtherRef}>
                       {isSlide  && <img ref={imgOtherRef} loading="eager"     decoding="async" alt="illustration du restaurant"/>
                    }</div>
                </div> }
                
                <div className="footerContainerRestau" >
                    <div className="infoNameNew">
                        <h3 className={`title midTitle ${name.length > 26 && 'lng'}`} translate="no">{name}</h3>
                        {isNew && <p className="isNew smallTitle" style={{fontStyle:"italic"}}>{name.length > 26 ? 'NOUV. !' : 'NOUVEAU !'}</p>}
                    </div>
                    <div className="separation"></div>
                    <div className="leftPart">
                        <h4 className="type XsmallText" ><i>{type}</i></h4>
                        <p className="cuisines smallText">{cuisines[0] && <i>{`Cuisine${cuisines[1] && 's'} ${cuisines[0]}${cuisines[1] && ` et ${cuisines[1]}` }`}</i> }</p>
                        <h4 className="city XsmallText" style={{color:"#606060"}} ><FaMapMarkerAlt color="#959595" size={10} className="icon"/> {visibleCity ? visibleCity : city}</h4>
                    </div>
                    <div className="rightPart XsmallText">
                        <div className="midTextBold">
                            <p style={{marginRight:'5px',color:"#2C2B2B"}}> {Number(note) !== 0 ? (Number(note) % 1 === 0 ? Number(note).toFixed(0) : Number(note).toFixed(1)) : ''}</p>
                            <MdOutlineStar  className="baseRate"  color="#cb9e3A" size={23} />
                            <MdOutlineStar  className="rateSmallComputer"  color="#cb9e3A" size={18} />
                        </div>
                        <div style={{color:"#737373"}}>{`(${nbr_review} ${nbr_review <2 ? 'avis' : 'avis'})`}</div>
                        <div>
                            <p>≈ {Math.round(total_price)}€ /</p> 
                            <IoPersonSharp color="#959595"  size={10}/>
                        </div>
                    </div>
                    
                </div> 
                {   
                    isLogin !== 2 && <div className="heart flexAllCenter pointer">
                        {!fav && <IoMdHeartEmpty className=" lowOpacityHover scndHeart" style={{zIndex:2,opacity:0.9}}  color={'white'} onClick={(e) => {e.preventDefault();e.stopPropagation();handleFav()}} size={35} />}
                        <IoMdHeart className=" lowOpacityHover " style={{zIndex:1,opacity:fav ? 1: 0.6}}  color={` ${fav  ? 'red' : 'black'}`} onClick={(e) => {e.preventDefault();e.stopPropagation();handleFav()}} size={35} />
                    </div>
                }
            </Link>       
        </div>
    )
}
const ContainerRestau = React.memo(ContainerRestauInner);

export { ContainerRestau }
